import { YUP_VALIDATIONS } from '@plug/helpers/yup-helpers';
import * as Yup from 'yup';

export const AffiliateRegisterNewPasswordSchema = Yup.object().shape({
  password: YUP_VALIDATIONS.password,
  passwordConfirmation: YUP_VALIDATIONS.passwordConfirmation,
});
